<template>
  <v-dialog v-model="open" persistent max-width="350px">
    <v-card>
      <v-card-title>
        <span>{{ $T('common.change_attribute', { attr: $T('attributes.rule_subscription') }) }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-container grid-list-lg text-xs-left>
        <v-layout column wrap>
          <v-flex>{{ $T('attributes.rule_subscription_age') }}</v-flex>
          <v-flex>
            <div class="c-left">
              <v-layout row wrap>
                <v-flex xs5>
                  <v-select
                    data-vv-name="min_age"
                    :items="ages"
                    ref="input_min_age"
                    :label="$T('attributes.min_age')"
                    v-model="min_age"
                    color="clr-primary"
                    v-validate="'integer|max:120'"
                    :error-messages="getMessage('min_age')"
                    required
                    :disabled="minAgeOnRule == -1 || loading"
                  ></v-select>
                </v-flex>
                <v-flex xs2>
                  <div class="c-hyphen">~</div>
                </v-flex>
                <v-flex xs5>
                  <v-select
                    data-vv-name="max_age"
                    :items="ages"
                    ref="input_min_age"
                    :label="$T('attributes.max_age')"
                    v-model="max_age"
                    color="clr-primary"
                    v-validate="'integer|max:120'"
                    :error-messages="getMessage('max_age')"
                    required
                    :disabled="minAgeOnRule == -1 || loading"
                  ></v-select>
                </v-flex>
              </v-layout>
              <div v-if="apiErrors.age" class="c-age-err">{{ apiErrors.age }}</div>
            </div>
          </v-flex>
          <v-flex
            ><div class="c-title">{{ $T('attributes.rule_subscription_gender') }}</div></v-flex
          >
          <v-flex>
            <v-radio-group v-model="gender" :disabled="loading">
              <v-radio
                v-for="item in [
                  { value: 0, label: $T('param.unspecified') },
                  { value: 1, label: $T('params.gender.male') },
                  { value: 2, label: $T('params.gender.female') },
                  { value: 3, label: $T('params.gender.other') },
                ]"
                color="clr-primary"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="clr-btn-cancel" flat @click.native="close">{{ $T('button.close') }}</v-btn>
        <v-btn color="clr-btn" flat @click.native="save" :disabled="!isSavable()" :loading="loading">{{
          $T('button.save')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MemberApi from '../../api/member';

export default {
  props: {
    initValue: { type: Object, required: false },
  },
  data() {
    return {
      gender: 0,
      min_age: 0,
      max_age: 0,
      open: false,
      loading: false,
      apiErrors: {},
      minAgeOnRule: -1,
    };
  },
  watch: {
    min_age: (newValue, oldValue) => {
      this.validateMinMax(newValue, this.max_age);
    },
    max_age: (newValue, oldValue) => {
      this.validateMinMax(this.min_age, newValue);
    },
    gender: (newValue, oldValue) => {
      this.fields.gender.dirty = true;
      this.fields.gender.invalid = false;
    },
  },
  computed: {
    ages() {
      const ages = [];
      ages.push({ text: $T('param.unspecified'), value: '0' });
      const min = this.minAgeOnRule == -1 ? 1 : this.minAgeOnRule;
      for (var i = min, n = 120; i < n; i++) {
        ages.push({ text: i, value: i });
      }
      return ages;
    },
    storeCommunity() {
      return this.$store.state.community.selectedCommunity;
    },
  },
  methods: {
    isSavable() {
      return this.isFormDirty() && !this.isFormInValid() && this.validateMinMaxField() && !this.loading;
    },
    isFormDirty() {
      return Object.keys(this.fields).some(key => this.fields[key].dirty);
    },
    isFormInValid() {
      return Object.keys(this.fields).some(key => this.fields[key].invalid);
    },
    validateMinMaxField() {
      return this.validateMinMax(this.min_age, this.max_age);
    },
    validateMinMax(min, max) {
      min = Number(min);
      max = Number(max);
      if (min > 0 && max > 0 && min > max) {
        this.apiErrors.age = $T('page.community.setting.rule_subscription.min_max_invalid');
        return false;
      } else {
        this.apiErrors.age = null;
        return true;
      }
    },
    async openDialog() {
      this.min_age = this.initValue && this.initValue.min_age ? Number(this.initValue.min_age) : 0;
      this.max_age = this.initValue && this.initValue.max_age ? Number(this.initValue.max_age) : 0;
      this.gender = this.initValue && this.initValue.gender ? Number(this.initValue.gender) : 0;
      this.fields.min_age.invalid = false;
      this.fields.max_age.invalid = false;
      this.fields.gender = { dirty: false, invalid: false };
      this.open = true;
      const rule = await MemberApi.getCommunityRule(this.storeCommunity.id);
      this.minAgeOnRule = rule && rule.ALL ? rule.ALL + 1 : 1;
    },
    getMessage(fieldName) {
      return this.apiErrors[fieldName] && this.apiErrors[fieldName][this.inputValue]
        ? this.apiErrors[fieldName][this.inputValue]
        : this.errors.collect(fieldName);
    },
    reValidate() {
      this.$validator.validateAll();
      this.$refs['input_' + this.fieldName].focus();
      this.loading = false;
    },
    close() {
      this.open = false;
      this.loading = false;
      this.minAgeOnRule = -1;
    },
    save() {
      this.loading = true;
      var _this = this;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit(
            'save',
            'rule_subscription',
            { min_age: this.min_age, max_age: this.max_age, gender: this.gender },
            this.initValue
          );
        } else {
          _this.loading = false;
          console.warn('there is invalid values.');
        }
      });
    },
  },
};
</script>

<style scoped>
.container {
  padding: 0px 24px 12px 24px;
}
.c-title {
  margin-top: 10px;
}
.c-hyphen {
  width: 100%;
  height: 100%;
  text-align: center;
  vertical-align: middle;
  line-height: 60px;
}
.c-left {
  position: relative;
  margin-left: 10px;
}
.c-age-err {
  position: absolute;
  top: 65px;
  color: #b71c1c;
}
.v-input--radio-group {
  margin-top: 0px;
  margin-left: 10px;
  padding-top: 10px;
}
</style>
